import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Topcarrentalcompanyinpune() {



  const cardData =
  {
    keyword: ' Top Car Rental Company in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Top Car Rental Company in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited stands out as a top car rental company in Pune, delivering professional and dependable mobility solutions for businesses and individuals alike. Whether you require executive sedans, SUVs, or premium cars, our diverse fleet meets a wide range of needs – from corporate travel and airport transfers to long-term rentals and special events. We prioritize comfort, safety, and punctuality, thanks to our experienced chauffeurs and well-maintained vehicles. With flexible rental plans (hourly, daily, or monthly), transparent pricing, and dedicated customer support, Pune Corporate Cars India Private Limited provides a seamless, high-quality car rental experience across Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

 "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
{
"name": "Best Car Hire Pune",
"description": "Best Car Hire Pune offers top-quality car rental services across Pune for corporate, personal, and business travel. The service focuses on reliability, comfort, and professional driving standards, providing a wide range of vehicles including sedans, SUVs, and luxury cars. With GPS tracking, trained chauffeurs, and prompt customer support, it ensures hassle-free bookings and a premium travel experience for all clients."
},
{
"name": "Leading Car Rental Pune",
"description": "Leading Car Rental Pune provides professional car rental solutions for individuals, corporate clients, and business travelers. The service features a well-maintained fleet, flexible rental plans, and personalized options to meet diverse travel requirements. With an emphasis on safety, punctuality, and customer satisfaction, it is the preferred choice for seamless transportation across Pune and nearby regions."
},
{
"name": "Premium Car Rental Pune",
"description": "Premium Car Rental Pune delivers high-end rental services for executives, managers, and corporate clients. Offering luxury sedans, SUVs, and chauffeur-driven vehicles, the service ensures comfort, elegance, and punctuality for business trips, client meetings, and special occasions. Vehicles are professionally maintained and drivers are highly trained for a superior travel experience."
},
{
"name": "Pune Chauffeur Car Hire",
"description": "Pune Chauffeur Car Hire provides professional driver-driven vehicles for corporate executives, VIP clients, and personal travel. The service emphasizes safety, discretion, and convenience, with trained chauffeurs, modern vehicles, and flexible scheduling. It is ideal for business meetings, airport transfers, and intercity travel with a focus on premium service standards."
},
{
"name": "Corporate Car Rental Pune",
"description": "Corporate Car Rental Pune specializes in providing businesses with reliable car rental services for employee transport, client visits, and corporate events. The service includes dedicated sedans, SUVs, and fleet management solutions, ensuring punctuality, safety, and convenience. Companies benefit from streamlined bookings, professional drivers, and flexible rental plans tailored for corporate mobility."
},
{
"name": "Business Car Hire Pune",
"description": "Business Car Hire Pune delivers professional car rental services for business travelers, executives, and corporate staff. With a focus on timely pickups, clean vehicles, and well-trained drivers, the service ensures efficient travel for meetings, client visits, and corporate events across Pune and surrounding areas."
},
{
"name": "Affordable Car Rental Pune",
"description": "Affordable Car Rental Pune offers budget-friendly rental services without compromising on quality, safety, or comfort. Suitable for both personal and corporate clients, the service provides well-maintained vehicles, flexible rental durations, and trained drivers, making it ideal for daily commuting, office travel, and short business trips."
},
{
"name": "Outstation Car Rental Pune",
"description": "Outstation Car Rental Pune provides safe and comfortable long-distance travel solutions for business trips, family visits, and intercity travel. Vehicles include sedans, SUVs, and luxury cars, all with trained drivers familiar with the best routes. The service ensures timely departures, efficient travel, and a hassle-free experience for outstation journeys."
},
{
"name": "Luxury Car Rental Pune",
"description": "Luxury Car Rental Pune delivers high-end vehicles including premium sedans, SUVs, and executive cars for corporate and personal travel. The service emphasizes comfort, style, and professionalism, with chauffeur-driven options available for business meetings, airport transfers, and special events, ensuring a first-class travel experience."
},
{
"name": "Self Drive Car Rental Pune",
"description": "Self Drive Car Rental Pune provides customers the flexibility to drive vehicles themselves, with a range of well-maintained sedans, SUVs, and hatchbacks. The service offers easy booking, affordable rates, and convenient pickup and drop-off options, ideal for personal travel, leisure trips, and business errands across Pune."
},
{
"name": "Sedan Car Rental Pune",
"description": "Sedan Car Rental Pune offers premium and mid-range sedans for corporate executives, employees, and personal travelers. The service ensures comfort, timely pickups, trained drivers (if required), and well-maintained vehicles, making it ideal for business meetings, office travel, and city commutes."
},
{
"name": "SUV Car Rental Pune",
"description": "SUV Car Rental Pune provides spacious, powerful, and comfortable SUVs for corporate teams, family travel, and long-distance journeys. The service focuses on safety, reliability, and convenience, with well-maintained vehicles and trained drivers for a premium commuting or outstation experience."
},
{
"name": "Airport Car Rental Pune",
"description": "Airport Car Rental Pune delivers punctual and comfortable transportation to and from Pune airport. The service features sedans, SUVs, and luxury vehicles with professional chauffeurs, ensuring timely pickups, smooth travel, and a hassle-free airport commute for business and leisure travelers alike."
},
{
"name": "Employee Car Rental Pune",
"description": "Employee Car Rental Pune offers dedicated car rental services for corporate employee commuting. With structured routes, multi-shift support, professional drivers, and reliable vehicles, it ensures safe, punctual, and comfortable travel for staff across offices, IT parks, and industrial zones in Pune."
},
{
"name": "Office Car Rental Pune",
"description": "Office Car Rental Pune provides flexible car rental solutions tailored for daily office commutes, client visits, and corporate errands. The service includes sedans, SUVs, and shuttle options with trained drivers, GPS tracking, and structured routes, ensuring reliable, comfortable, and professional transportation for office employees and managers."
}
],

"tableData": [
["Best Car Hire Pune", "Leading Car Rental Pune"],
["Premium Car Rental Pune", "Pune Chauffeur Car Hire"],
["Corporate Car Rental Pune", "Business Car Hire Pune"],
["Affordable Car Rental Pune", "Outstation Car Rental Pune"],
["Luxury Car Rental Pune", "Self Drive Car Rental Pune"],
["Sedan Car Rental Pune", "SUV Car Rental Pune"],
["Airport Car Rental Pune", "Employee Car Rental Pune"],
["Office Car Rental Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Top Car Rental Company in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited is recognized as one of the leading car rental companies in Pune, offering reliable and professional services for corporate and personal travel."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles",
    "WhyChoosedescription": "We provide a diverse fleet including sedans, SUVs, tempo travellers, and buses, catering to the varied needs of businesses and individuals."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs",
    "WhyChoosedescription": "Our trained and courteous drivers ensure safe, punctual, and comfortable journeys for all passengers."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "We offer customizable rental plans for hourly, daily, or monthly use, tailored to meet the specific requirements of our clients."
  },
  {
    "WhyChooseheading": "Reliable & Timely Service",
    "WhyChoosedescription": "Our top priority is punctuality and reliability, ensuring seamless travel experiences for corporate and personal clients alike."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "We provide round-the-clock assistance for bookings, emergencies, and travel adjustments, ensuring a hassle-free experience."
  },
  {
    "WhyChooseheading": "Safe & Well-Maintained Vehicles",
    "WhyChoosedescription": "All cars are regularly serviced and sanitized, equipped with modern safety features to guarantee a secure and comfortable ride."
  },
  {
    "WhyChooseheading": "Easy Booking & Efficient Coordination",
    "WhyChoosedescription": "Our streamlined booking process and reliable coordination make renting cars simple and convenient for businesses and individuals."
  }
]




























  }

const faqData = [
  {
    question: 'Is Pune Corporate Cars India Private Limited one of the top car rental companies in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited is recognized as a trusted and professional car rental company providing reliable services in Pune.',
  },
  {
    question: 'What types of car rental services do you offer in Pune?',
    answer: 'We provide corporate cab services, employee transportation, airport transfers, outstation travel, and event-specific car rentals.',
  },
  {
    question: 'How can companies book car rental services with Pune Corporate Cars India Private Limited?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'Do you offer customized car rental plans for corporate clients?',
    answer: 'Yes, we provide tailored car rental solutions based on the company’s requirements, staff strength, and travel frequency.',
  },
  {
    question: 'What vehicle options are available for car rentals in Pune?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on travel needs.',
  },
  {
    question: 'Can companies avail monthly or annual car rental contracts?',
    answer: 'Absolutely. We provide flexible monthly and annual rental contracts with transparent pricing.',
  },
  {
    question: 'Do you provide airport transfer services as part of car rentals?',
    answer: 'Yes, we offer punctual and reliable airport pickup and drop services for corporate and private clients.',
  },
  {
    question: 'What safety measures do you follow for car rental services?',
    answer: 'Our vehicles are GPS-enabled, sanitized regularly, and our drivers follow strict safety and hygiene protocols.',
  },
  {
    question: 'What payment modes are accepted for car rental services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and offer corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pranav Jadhav',
    feedback: 'Pune Corporate Cars India Private Limited is our preferred car rental partner. Professional, reliable, and great service overall.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aishwarya Salunkhe',
    feedback: 'Excellent car rental service for corporate and business travel. Highly recommend Pune Corporate Cars India Private Limited.',
    rating: 5,
  },
];





















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Top Car Rental Company in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/top-car-rental-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited is a leading car rental company in Pune, offering premium, affordable, and chauffeur-driven car rentals for corporate clients, business travel, airport transfers, and self-drive options. Choose from sedans, SUVs, and luxury cars for all your corporate and personal needs.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "5000", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/top-car-rental-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>Top Car Rental Company in Pune | Corporate & Business Car Hire | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited is a leading car rental company in Pune, offering premium, affordable, and chauffeur-driven car rentals for corporate clients, business travel, airport transfers, and self-drive options. Choose from sedans, SUVs, and luxury cars for all your corporate and personal needs."
  />

  <meta
    name="keywords"
    content="Best Car Hire Pune, Leading Car Rental Pune, Premium Car Rental Pune, Pune Chauffeur Car Hire, Corporate Car Rental Pune, Business Car Hire Pune, Affordable Car Rental Pune, Outstation Car Rental Pune, Luxury Car Rental Pune, Self Drive Car Rental Pune, Sedan Car Rental Pune, SUV Car Rental Pune, Airport Car Rental Pune, Employee Car Rental Pune, Office Car Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Topcarrentalcompanyinpune;